<template>
	<div>
		<div class="mainQueryBox">
			<div class="queryLeft">
				<div class="queryBox">
					<span class="queryTitle">省、直辖市：</span>
					<span class="queryValue">
						<el-select size="medium" filterable allow-create v-model="provinces" placeholder="请选择">
							<el-option v-for="(item, index) in provincesGrouped" :label="item" :value="item" :key="index"></el-option>
						</el-select>
					</span>
				</div>
				<div class="queryBox">
					<span class="queryTitle">城市：</span>
					<span class="queryValue">
						<el-select size="medium" @visible-change="visibleChange" filterable allow-create v-model="city" placeholder="请选择">
							<el-option v-for="(item, index) in cityGrouped" :label="item" :value="item" :key="index"></el-option>
						</el-select>
					</span>
				</div>
				<div class="queryBox">
					<span class="queryTitle">任务名称：</span>
					<span class="queryValue"><el-input size="medium" v-model="taskname" placeholder="请输入标题"></el-input></span>
				</div>
				<el-button class="queryBox" size="medium" type="primary" @click="loadData">搜索</el-button>
				<el-button class="queryBox" size="medium" @click="reset">重置</el-button>
			</div>
		</div>
		<div class="tableBox">
			<el-table border :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
				<el-table-column prop="taskname" label="任务名称" align="center"></el-table-column>
				<el-table-column prop="provinces" label="省、直辖市" align="center"></el-table-column>
				<el-table-column prop="city" label="城市" align="center"></el-table-column>
				<el-table-column prop="phonenumcount" label="抽取数量" align="center"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-link type="primary" :underline="false" @click="importData(scope.row.id)">导入</el-link>
						<el-link style="margin-left: 10px;" type="primary" :underline="false" @click="previewDAta(scope.row.id)">预览</el-link>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.pageNo"
					:page-sizes="[5, 10, 50, 100, 200, 300, 400]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
				></el-pagination>
			</div>
		</div>
		<previewSampling ref="previewSampling"></previewSampling>
	</div>
</template>

<script>
import previewSampling from './previewSampling/index.vue';
export default {
	components: { previewSampling },
	data() {
		return {
			taskname: '',
			city: '',
			cityGrouped: [],
			provinces: '',
			provincesGrouped: [],
			multipleSelection: [],
			tableData: [],
			source: '',
			surveyId: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			}
		};
	},
	created() {
		this.surveyId = this.$route.query.id;
		this.source = this.$route.query.source;
		this.loadData();
		this.getPhoneLibProviceGroup(); //  获取省份分组信息
	},
	methods: {
		importData(id) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.importPhoneTaskToSample}`,
				method: 'POST',
				data: {
					id: id,
					qid: that.surveyId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						loading.close();
						that.$emit('importDataOk');
						that.$message.success(res.message);
					} else {
						loading.close();
						that.provincesGrouped = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		previewDAta(id) {
			this.$refs.previewSampling.openVisible(id);
		},
		getPhoneLibProviceGroup() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.getPhoneLibProviceGroup}`,
				method: 'POST',
				data: {
					id: that.surveyId
				},
				cb(res) {
					if (res.code == 0) {
						let arr = res.resultBody;
						let newArr = arr.filter(function(value, index, self) {
							return self.indexOf(value) === index;
						});
						that.provincesGrouped = newArr;
					} else {
						that.provincesGrouped = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		visibleChange(value) {
			console.log(value);
			if (value) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.getPhoneLibCityGroup}`,
					method: 'POST',
					data: {
						provinces: this.provinces
						// id: id
					},
					cb(res) {
						if (res.code == 0) {
							let arr = res.resultBody;
							let newArr = arr.filter(function(value, index, self) {
								return self.indexOf(value) === index;
							});
							that.cityGrouped = newArr;
						}
					}
				};
				this.$util.request(params);
			}
		},
		reset() {
			this.city = '';
			this.provinces = '';
			this.loadData();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryPhoneTaskList}`,
				method: 'POST',
				data: {
					state: 2,
					id: that.surveyId,
					city: that.city,
					provinces: that.provinces,
					taskname: that.taskname,
					currentPage: that.pagination.pageNo,
					pageSize: that.pagination.pageSize
				},
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.loadData();
		}
	}
};
</script>

<style lang="scss" scoped>
.mainQueryBox {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	.queryLeft {
		display: flex;
		.queryBox {
			display: flex;
			margin-left: 10px;
			.queryTitle {
				line-height: 36px;
			}
			.queryValue {
				margin-left: 10px;
			}
		}
		.queryBox:first-child {
			margin-left: 0px;
		}
	}
}

.tableBox {
	margin-bottom: 20px;
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
</style>
